import { ORDER_STATUSES, OrderStatus } from '../types/order-status.type';

export const formatStatus = (status: OrderStatus) => {
  switch (status) {
    case ORDER_STATUSES.ABANDONED:
      return 'Abandonnée';
    case ORDER_STATUSES.CANCELED:
      return 'Annulée';
    case ORDER_STATUSES.PAID:
      return 'Payée';
    case ORDER_STATUSES.REFUSE:
      return 'Refusée';
    case ORDER_STATUSES.WAITING:
      return 'En attente';
    case ORDER_STATUSES.REFUND:
      return 'Remboursée';
    case ORDER_STATUSES.PARTIAL:
      return 'Partielle';
  }
};
